module.exports = __webpack_public_path__ + "img/cr2.ad66f1d3.png";